import { render, staticRenderFns } from "./progressiveDiscount.vue?vue&type=template&id=22129b3e&scoped=true&"
import script from "./progressiveDiscount.vue?vue&type=script&lang=js&"
export * from "./progressiveDiscount.vue?vue&type=script&lang=js&"
import style0 from "./progressiveDiscount.vue?vue&type=style&index=0&id=22129b3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22129b3e",
  null
  
)

export default component.exports